<template>
  <div class="row title-block">
    <div
      v-if="isOnlyTitle"
      class="col-20 page-title"
    >
      {{ title }}
    </div>
    <div
      v-else
      class="col-20 col-sm-8 col-md-6 page-title"
    >
      {{ title }}
    </div>
    <div class="col-20 col-sm-12 col-md-9 text-wrapper">
      <div
        v-if="subtitle"
        class="subtitle"
      >
        {{ subtitle }}
      </div>
      <div
        v-if="text"
        class="text"
      >
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    }
  },
  computed: {
    isOnlyTitle () {
      return !this.subtitle && !this.text
    }
  }
}
</script>

<style scoped lang="scss">
  .title-block {
    box-shadow: 0px 6.93056px 27.7222px rgba(0, 0, 0, 0.05);
    border-radius: 11.0889px;
    color: white;
    background-image: url('./../assets/img/intro-background.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    min-height: 106px;
    padding: 2rem 1.375rem;
    margin-bottom: 0.75rem;
    .text-wrapper {
      .subtitle {
        font-size: 1.0625rem;
        margin-bottom: 0.5rem;
      }
      .text {
        font-size: 0.625rem;
        line-height: 170%;
      }
    }
  }
</style>
